/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Grid, Cell } from './Grid';
import Spacer from './Spacer';

const ReadOnlyInputRow = (props) => {
  const styleClass = classnames('cmp-readonlyinputrow', {
    'is-clickable': !!props.onClick,
  });
  return (
    <div className={styleClass} style={props.style} onClick={props.onClick}>
      <div className="font-caption-1">
        <FormattedMessage id={props.title} />
      </div>
      <Spacer size="6" />

      <Grid justifyContent="space-between" alignItems="center">
        <Cell width="80%">
          <div className="font-body font-color-gsDarkest">
            {props.value}
          </div>
        </Cell>
        <Cell>
          <div className="font-caption">
            {props.rightSide}
          </div>
        </Cell>
      </Grid>
    </div>
  );
};
ReadOnlyInputRow.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  rightSide: PropTypes.any,
  hasRightChevron: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default ReadOnlyInputRow;
